/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-data-processing-agreement',
    imports: [],
    templateUrl: './data-processing-agreement.component.html',
    styleUrl: './data-processing-agreement.component.scss'
})
export class DataProcessingAgreementComponent {

}
